import searchBar, { en as searchBarEN, ca as searchBarCA } from './searchbar'

export default {
  topic: 'Tema o autor',
  searchPlaceholder: 'Prueba "Clima"',
  age: 'Edad',
  agePlaceholder: 'Elige un rango',
  ageEmptyLabel: 'Todas las edades',
  categories: 'Categorías',
  categoryPlaceholder: 'Elige una categoría',
  categoryEmptyLabel: 'Todas las categorías',
  skills: 'Habilidades',
  skillPlaceholder: 'Elige una habilidad',
  skillEmptyLabel: 'Todas las habilidades',
  ods: 'ODS',
  odsPlaceholder: 'Elige un ODS',
  odsEmptyLabel: 'Todos los ODS',
  creations: 'Creaciones',
  creationsEmptyLabel: 'Todas',
  language: 'Idioma',
  languagePlaceholder: 'Elige un idioma',
  languageEmptyLabel: 'Todos los idiomas',
  advanced: 'Búsqueda avanzada',
  search: 'B',
  moreFilters: 'Más filtros',
  recommends: 'Kimple te recomienda',
  programs: '{n} Programa educativo | {n} Programas educativos',
  resources: '{n} Recurso | {n} Recursos',
  kimpleNewest: 'Últimos recursos agregados a Kimple',
  newest: 'Últimos recursos agregados',
  errors: {
    noResult: '¡Oh no! No se encontraron resultados para tu búsqueda',
    emptyResultExplanation: 'Parece que no hay ningún recurso que cumpla con las condiciones de búsqueda. ¡Prueba algo nuevo!',
    noResultsForPrograms: 'No se encontraron programas para tu búsqueda',
    noResultsForResources: 'No se encontraron recursos para tu búsqueda',
    noResultsForKimpleFolders: 'No se encontraron carpetas para tu búsqueda',
    emptySearchResultExplanation: 'Parece que no hay ningún recurso que cumpla con las condiciones de búsqueda. ¡Prueba algo nuevo!'
  },
  backToFeed: 'Volver al inicio',
  showMore: 'Ver más',
  weFind: 'Encontramos ',
  educationalPrograms: '{n} programa educativo | {n} programas educativos',
  comma: ', ',
  and: ' y ',
  educationalResources: '{n} recurso | {n} recursos',
  yourSearch: ' en tu búsqueda',
  programsLabel: 'Programas educativos',
  subjectIdsLabel: 'Áreas cruzadas',
  subjectIds: {
    math: 'Matemática',
    language: 'Lengua',
    art: 'Arte',
    transversal: 'Transversal',
    socialSciences: 'Ciencias sociales',
    naturalSciences: 'Ciencias naturales',
    languages: 'Idiomas',
    technology: 'Tecnología'
  },
  resourceTypesLabel: 'Tipo de recurso',
  resourceTypes: {
    workshop: 'Taller',
    project: 'Proyecto',
    case: 'Caso',
    didacticSecuence: 'Secuencia',
    exercise: 'Ejercicio'
  },
  necessaryMaterialsLabel: 'Dispositivos necesarios',
  necessaryMaterials: {
    electronic: 'Disp. electrónicos',
    physical: 'Útiles',
    downloadable: 'Contenido descargable'
  },
  classes: 'Cantidad de clases',
  implementationLabel: 'Implementación',
  implementationType: {
    online: 'Online',
    offline: 'Offline',
    both: 'Online/Offline'
  },
  clearFilters: 'Limpiar Filtros',
  checked: 'Seleccionado',
  notChecked: 'No seleccionado',
  searchBar,
  educationalKimpleFolders: '{n} carpeta | {n} carpetas',
  kimpleFolders: '{n} Carpeta | {n} Carpetas',
  kimpleFoldersCarousel: {
    title: 'Carpetas Kimple',
    linkText: 'Ver todas'
  },
  ephemerideKimpleFolderSeeMore: 'Ver carpeta',
  list: 'Lista',
  grid: 'Grilla'
}

export const en = {
  topic: 'Subject or author',
  searchPlaceholder: 'Try "Climate"',
  age: 'Age',
  agePlaceholder: 'Choose a range',
  ageEmptyLabel: 'All ages',
  categories: 'Categories',
  categoryPlaceholder: 'Choose a category',
  categoryEmptyLabel: 'All categories',
  skills: 'Skills',
  skillPlaceholder: 'Choose a skill',
  skillEmptyLabel: 'All skills',
  ods: 'SDG',
  odsPlaceholder: 'Choose a SDG',
  odsEmptyLabel: 'All SDGs',
  creations: 'Creations',
  creationsEmptyLabel: 'All',
  language: 'Language',
  languagePlaceholder: 'Choose a language',
  languageEmptyLabel: 'All languages',
  advanced: 'Advanced search',
  search: 'Search',
  moreFilters: 'More filters',
  recommends: 'Kimple recommends',
  programs: '{n} Educational Program | {n} Educational Programs',
  resources: '{n} Resource | {n} Resources',
  kimpleNewest: 'Latest resources added to Kimple',
  newest: 'Latest resources added',
  errors: {
    noResult: 'Oh no! No results found for your search',
    emptyResultExplanation: 'No resource seems to match your search criteria, try something new!',
    noResultsForPrograms: 'No programs found for your search',
    noResultsForResources: 'No resources found for your search',
    noResultsForKimpleFolders: 'No folders were found for your search',
    emptySearchResultExplanation: 'No resource seems to match your search criteria, try something new!'
  },
  backToFeed: 'Go back',
  showMore: 'Show more',
  weFind: 'We\'ve found ',
  educationalPrograms: '{n} educational program | {n} educational programs',
  comma: ', ',
  and: ' and ',
  educationalResources: '{n} resource | {n} resources',
  yourSearch: ' for your search',
  programsLabel: 'Educational Programs',
  subjectIdsLabel: 'Cross-sectional areas',
  subjectIds: {
    math: 'Maths',
    language: 'Grammar',
    art: 'Art',
    transversal: 'Transversal',
    socialSciences: 'Social science',
    naturalSciences: 'Natural science',
    languages: 'Languages',
    technology: 'Technology'
  },
  resourceTypesLabel: 'Resource type',
  resourceTypes: {
    workshop: 'Workshop',
    project: 'Project',
    case: 'Case',
    didacticSecuence: 'Didactic secuence',
    exercise: 'Exercise'
  },
  necessaryMaterialsLabel: 'Necessary devices',
  necessaryMaterials: {
    electronic: 'Electronic devices',
    physical: 'Physical',
    downloadable: 'Downloadable'
  },
  classes: 'Amount of classes',
  implementationLabel: 'Implementation',
  implementationType: {
    online: 'Online',
    offline: 'Offline',
    both: 'Online/Offline'
  },
  clearFilters: 'Clear filters',
  checked: 'Checked',
  notChecked: 'Not checked',
  searchBar: searchBarEN,
  educationalKimpleFolders: '{n} folder | {n} folders',
  kimpleFolders: '{n} Folder | {n} Folders',
  kimpleFoldersCarousel: {
    title: 'Kimple folders',
    linkText: 'See all'
  },
  ephemerideKimpleFolderSeeMore: 'See folder',
  list: 'List',
  grid: 'Grid'
}

export const ca = {
  topic: 'Tema o autor',
  searchPlaceholder: 'Prova "Clima"',
  age: 'Edat',
  agePlaceholder: 'Tria un rang',
  ageEmptyLabel: 'Totes les edats',
  categories: 'Categories',
  categoryPlaceholder: 'Tria una categoria',
  categoryEmptyLabel: 'Totes les categories',
  skills: 'Habilitats',
  skillPlaceholder: 'Tria una habilitat',
  skillEmptyLabel: 'Totes les habilitats',
  ods: 'ODS',
  odsPlaceholder: 'Tria un ODS',
  odsEmptyLabel: 'Totes les ODS',
  creations: 'Creacions',
  creationsEmptyLabel: 'Totes',
  language: 'Idioma',
  languagePlaceholder: 'Tria un idioma',
  languageEmptyLabel: 'Tots els idiomes',
  advanced: 'Cerca avançada',
  search: 'Cerca',
  moreFilters: 'Més filtress',
  recommends: 'Kimple et recomana',
  programs: '{n} Programa educatiu | {n} Programes educatius',
  resources: '{n} Recurs | {n} Recursos',
  kimpleNewest: 'Últims recursos afegits a Kimple',
  newest: 'Últims recursos afegits',
  errors: {
    noResult: 'Vaja! La teva cerca no ha donat resultats',
    emptyResultExplanation: 'No sembla que cap recurs compleixi amb les condicions de cerca, intenta una altra cosa',
    noResultsForPrograms: 'No s\'han trobat programes que coincideixin amb la teva cerca',
    noResultsForResources: 'No s\'han trobat recursos que coincideixin amb la teva cerca',
    noResultsForKimpleFolders: 'No s\'han trobat carpetes per a la teva cerca',
    emptySearchResultExplanation: 'No sembla que cap recurs compleixi amb les condicions de cerca, intenta una altra cosa'
  },
  backToFeed: 'Torna a l\'inici',
  showMore: 'Ensenya\'m més',
  weFind: 'Hem trobat ',
  educationalPrograms: '{n} programa educatiu | {n} programes educatius',
  comma: ', ',
  and: ' y ',
  educationalResources: '{n} recurs | {n} recursos',
  yourSearch: ' a la teva cerca',
  programsLabel: 'Programes educatius',
  subjectIdsLabel: 'Àrees Creuades',
  subjectIds: {
    math: ' Matemàtica',
    language: 'Llengua',
    art: 'Art',
    transversal: 'Transversal',
    socialSciences: 'Ciències socials',
    naturalSciences: 'Ciències naturals',
    languages: 'Idiomes',
    technology: 'Tecnologia'
  },
  resourceTypesLabel: 'Tipus de recurs',
  resourceTypes: {
    workshop: 'Taller',
    project: 'Projecte',
    case: 'Cas',
    didacticSecuence: 'Seqüència Didàctica',
    exercise: 'Exercici'
  },
  necessaryMaterialsLabel: 'Dispositius Necessaris',
  necessaryMaterials: {
    electronic: 'Disp. electrònics',
    physical: 'Materials',
    downloadable: 'Contingut descarregable'
  },
  classes: 'Nombre de classes',
  implementationLabel: 'Implementació',
  implementationType: {
    online: 'Online',
    offline: 'Offline',
    both: 'Online/Offline'
  },
  clearFilters: 'Netejar Filtres',
  checked: 'Seleccionat',
  notChecked: 'Sense seleccionar',
  searchBar: searchBarCA,
  educationalKimpleFolders: '{n} carpeta | {n} carpetes',
  kimpleFolders: '{n} Carpeta | {n} Carpetes',
  kimpleFoldersCarousel: {
    title: 'Carpetes Kimple',
    linkText: 'Veure totes'
  },
  ephemerideKimpleFolderSeeMore: 'Veure carpeta',
  list: 'Llista',
  grid: 'Graella'
}
